/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p,ul{margin:0;padding-left:25px}ul>li{margin:0}.layer-details-pane{word-break:break-all;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}"];
export { styles as styles };
